
import _BaseAPIService from './_BaseAPIService';

const apiService = _BaseAPIService.instance;

const ProductPageService = {
  // Define your API functions here
  getTop20Products: async ({count=20}) => {
    try{
        const response = await apiService.get(`/api/productspage/fetchproducts?count=${count}`);
      
        return response.data;

    }catch(err){
        console.log(err)
    }
   
  },

  getCategory: async ({OrgId}) => {
    try{
      
      let response;

      if (!OrgId) {
        
        response = await apiService.get(`/api/productspage/category`);
      } else {
       
        response = await apiService.get(`/api/productspage/category?orgId=${OrgId}`);
      }
      console.log(response)
      return response.data;

    }catch(err){
        console.log(err)
    }
   
  },

  getOrganization: async () => {
    try{
        const response = await apiService.get(`/api/productspage/organizations`);
        console.log(response)
        return response.data;

    }catch(err){
        console.log(err)
    }
   
  },

  getThisItem: async ({pageNum=1, pageSize=20, restaurantName='', itemName='', categoryName='' }) => {
    
    
    try {
          let res;
      
          // Base URL
          let url = `/api/productspage?page=${pageNum}&pageSize=${pageSize}`;
      
          // Collect filters dynamically
          const filters = [];
      
          if (restaurantName.length > 0) filters.push(`restaurantName=${restaurantName}`);
          if (itemName.length > 0) filters.push(`itemName=${itemName}`);
          if (categoryName.length > 0) filters.push(`categoryName=${categoryName}`);

          
      
          // Append filters to the URL if any exist
          if (filters.length > 0) {
            url += `&${filters.join("&")}`;
          }else{
            const response = await apiService.get(`/api/productspage/fetchproducts?count=20`);
      
            return response.data;

          }



          console.log(url)
      
          // // Call API
          res = await apiService.get(url);
          console.log(res)
          return res.data.items;
      
 
    }catch(err){
        console.log(err)
    }
   
  },
};

export default  ProductPageService;
